<div *ngIf="!isLoading">
    <app-reports-group-form [formModel]="model" ></app-reports-group-form>
</div>
